<template>
  <div v-if="isVisible" class="modal-overlay">
    <div class="modal-content">
      <!-- Заголовок с поиском и закрытием окна -->
      <div class="modal-header">
        <div class="search-input">
          <!-- Таб с переключателями -->
          <div class="tabs">
            <button :class="{ active: activeTab === 'related' }" @click="setTab('related')">Сопутствующие товары</button>
            <button :class="{ active: activeTab === 'similar' }" @click="setTab('similar')">Аналогичные товары</button>
          </div>
        </div>
        <button @click="closeModal" class="btn-close-modal"></button>
      </div>

      <!-- Загрузка товаров -->
      <div v-if="localLoading" class="loader-container">
        <div class="spinner"></div>
      </div>
      
      <div v-else class="product-list">
        <!-- Таблица товаров -->
        <table class="modern-table">
          <thead>
            <tr>
              <th>Фото</th>
              <th>Наименование</th>
             
              <th>Пуск. ток</th>
              <th>Емкость</th>
            
              <th colspan="2">Наличие у нас</th>
              <th>Наличие у поставщиков (бонус)</th>
              <th>Цена (руб.)</th>
              <th>Бонус</th>
             
              <th>Количество</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in displayedProducts" :key="product.id" :class="{ 'in-order': isProductInOrder(product.id) }">
              <td style="max-width:50px"><img :src="product.jpg_url" alt="Фото товара" style="max-width:50px"/></td>
              <td @click="emitAddProduct(product)" style="position:relative;"><a :href="product.href" target="_blank">{{ product.name }}</a><span>{{ product.artikul }}</span>
      <div class="property">
        <span v-if="product.korpus">Тип корпуса: {{ product.korpus }}; </span>
        <span v-if="product.length">Габариты: {{ product.length || product.width || product.height ? 
    `${product.length ? product.length : ''}*${product.width ? product.width : ''}*${product.height ? product.height : ''}` 
    : '' }}; </span>
    <span v-if="product.polarka">Полярность: {{ product.polarka }}; </span> 
    <div class="count">{{ product.count }} шт</div>
      </div>
      <span v-if="isProductInOrder(product.id)" class="in-order-label">В заказе</span></td>
           
              <td>{{ product.starttok }}</td>
              <td>{{ product.emkost }}</td>
          
              <!-- Фильтрация склада m через вычисляемое свойство filteredSkladm -->
              <td style="min-width: 85px; text-align: right;">
                <p v-for="m in filteredSkladm(product)" :key="m.id">
                  {{ m.id }}
                </p>
              </td>
              <td>
                <p v-for="m in filteredSkladm(product)" :key="m.id + '_count'">
                  <span>{{ m.count }}</span>
                </p>
              </td>
              <td>
                <p v-for="p in filteredSkladp(product)" :key="p.id">
                  {{ p.id }} -
                  <span>{{ p.count }}</span>
                  <span class="bonus">{{ p.seba }}</span>
                </p>
              </td>
              <td>{{ product.price }} руб.</td>
              <td>{{ product.seba }}</td>
              <td>
                <div v-if="isProductInOrder(product.id)" class="button_quantity">
                  <button @click.stop="decreaseQuantity(product)" class="qty-btn qty-btn-decrease">-</button>
                  <span class="quantity">{{ getQuantity(product) }}</span>
                  <button @click.stop="increaseQuantity(product)" class="qty-btn qty-btn-increase">+</button>
                </div>
                <button v-else @click="emitAddProduct(product)" class="add-btn">Добавить</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Показать еще -->
      <button v-if="hasMoreProducts" @click="loadMore" class="load-more-btn">Показать еще</button>
    </div>
  </div>
</template>

<script>import { ORDERS_API_BASE } from '@/config/api';

import axios from 'axios';

export default {
  props: {
  products: {
    type: Array,
    required: true,
    default: () => [] // Задает products как пустой массив по умолчанию
  },
    isVisible: Boolean,
    isProductInOrder: Function,
    loading: Boolean,
    korpusType: String, // Тип корпуса для аналогичных товаров
  },
  data() {
    return {
      searchQuery: '',
      displayedProducts: [],
      itemsPerPage: 30,
      currentPage: 1,
      totalItems: 0,
      localLoading: this.loading,
      activeTab: 'related', // 'related' или 'similar'
    };
  },
  computed: {
    filteredSkladm() {
      return (product) => {
        return product.skladm ? product.skladm.filter(m => m.count > 0) : [];
      };
    },
    filteredSkladp() {
      return (product) => {
        return product.skladp ? product.skladp.filter(p => p.count > 0) : [];
      };
    },
    hasMoreProducts() {
      return this.displayedProducts.length < this.totalItems;
    },
  },
  methods: {
 getQuantity(product) {
  const foundProduct = this.products.find(p => p.id === product.id);
  return foundProduct ? foundProduct.quantity : 1;
},
    emitAddProduct(product) {
      if (this.isProductInOrder(product.id)) {
        // Если товар уже добавлен, удаляем его
        this.$emit('remove-product', product.id);
      } else {
        // Если товар не добавлен, добавляем его
        this.$emit('add-product', product);
      }
    },
    increaseQuantity(product) {
      this.$emit('increase-product', product.id);
    },
    decreaseQuantity(product) {
      this.$emit('decrease-product', product.id);
    },
    closeModal() {
      this.$emit('close');
    },
    setTab(tab) {
      this.activeTab = tab;
      this.currentPage = 1;
      this.fetchProducts();
    },
    onSearch() {
      this.currentPage = 1;
      this.fetchProducts();
    },
    resetSearch() {
      this.searchQuery = '';
      this.onSearch();
    },
    loadMore() {
      this.currentPage++;
      this.fetchProducts();
    },
    fetchProducts() {
      this.localLoading = this.currentPage === 1;
      
      // Определяем обработчик в зависимости от вкладки
      const endpoint = this.activeTab === 'related' 
        ? ORDERS_API_BASE + '/soputka.php' 
        : ORDERS_API_BASE + '/analog.php';

      const params = {
        query: this.searchQuery,
        page: this.currentPage,
        korpusType: this.activeTab === 'similar' ? this.korpusType : undefined, // добавляем тип корпуса только для аналогичных товаров
      };

      axios
        .get(endpoint, { params })
        .then((response) => {
          const { items, totalItems } = response.data;
          this.displayedProducts = this.currentPage === 1 ? items : [...this.displayedProducts, ...items];
          this.totalItems = totalItems;
          this.localLoading = false;
        })
        .catch((error) => {
          console.error('Ошибка при загрузке товаров:', error);
          this.localLoading = false;
        });
    },
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        this.fetchProducts();
      }
    },
    loading(newVal) {
      this.localLoading = newVal;
    },
  },
};
</script>



<style scoped>
button:not(:disabled), [type=button]:not(:disabled), [type=reset]:not(:disabled), [type=submit]:not(:disabled) {
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
}
.qty-btn {
  margin: 0 4px;
}
.in-order {
  background-color: #f0f8ff;
}
.in-order-label {
  color: #ff4500;
  font-weight: bold;
  margin-left: 4px;
}
.add-btn {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 4px;
}

.modal-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  
}


.modal-content {
    background: white;
    padding: 0px;
    border-radius: 5px;
    max-width: 80%;
    max-height: 80%;
    overflow-y: auto;
    position: relative;
    right: 0;
    left: 0;
    z-index: 1040;
    --default-padding: 56px 296px;
    max-width: 1192px;
    width: 100%;
    height: 100%;
    margin: 40px auto;
    border-radius: 0px;
    background: #fafafa;
    max-height: calc(100vh - 80px);
    overflow: hidden;
    margin: 60px auto 40px auto;
    overflow-y: scroll;
    position: relative;
}

.modal-content {
    background: #ffffff;
    width: 100%;
    max-width: 1340px;
    position: relative;
    overflow-y: auto;
    max-height: 95vh;
}

td span {
    background: #ffc107;
    padding: 0px 4px;
    font-size: 10px;
    border: solid 1px #c7b0b0;
}


/* Фиксированный заголовок с поиском и кнопкой закрытия */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
  padding: 10px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}

.search-input_products {
  display: flex;
  gap: 10px;
  align-items: center;
}

.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #ff5353;
}

table.modern-table {
  width: 100%;
  border-collapse: collapse;
}

/* Фиксированные заголовки столбцов таблицы */
table.modern-table thead tr th {
  position: sticky;
  top: 50px; /* отступ от верха */
  background: #ffffff;
  z-index: 5;
}

table.modern-table th,
table.modern-table td {
  border: 1px solid #dee2e6;
  padding: 8px;
  text-align: left;
}

.in-order-label {
  color: #ff4500;
     color: #ff4500;
    font-weight: bold;
    margin-left: 4px;
    background: transparent;
    border: 0px;
    padding: 0px;
    font-size: 12px;
}

.qty-btn, .add-btn {
  margin: 0 4px;
}

.load-more-btn {
  display: block;
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  background-color: #fafafa;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  color: black;
    font-weight: 500;
}

.qty-btn,
.add-btn {
  margin: 0 4px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    color: #ffffff;
    border-radius: 5px;
    transition: background 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Стили для кнопок увеличения и уменьшения */
.qty-btn-decrease {
    color: #000000;
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
    box-shadow: none;
    font-weight: 600;
}

.qty-btn-increase {
  
    color: #000000;
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
    box-shadow: none;
}

.qty-btn:hover {
  opacity: 0.8;
}

.add-btn {
    background-color: #4CAF50!important;
    background-image: linear-gradient(180deg, #22c993, #20a77f)!important;
    color: #fff;
    width: 67%;
}

.load-more-btn {
  display: block;
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  background-color: #fafafa;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  color: black;
    font-weight: 500;
}

.load-more-btn:hover {
  background-color: #fafafa;
}

.button_quantity {
  display:flex;
  align-items:center;
  justify-content:center;
}

.input-field.clear-btn.empty {
  min-width: 250px;
  min-height: 35px;
}

.btn-close-modal:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF5353' d='M7.113 6.176a.6.6 0 0 1 .848 0L12 10.214l4.038-4.038a.6.6 0 0 1 .849 0l.937.937a.6.6 0 0 1 0 .848L13.785 12l4.04 4.04a.6.6 0 0 1 0 .848l-.937.937a.6.6 0 0 1-.849 0L12 13.784l-4.038 4.04a.6.6 0 0 1-.849 0l-.937-.937a.6.6 0 0 1 0-.848l4.04-4.04-4.039-4.038a.6.6 0 0 1 0-.849l.937-.936Z'/%3E%3C/svg%3E");
    background-position: 50%;
    background-repeat: no-repeat;
    bottom: 0;
    content: "";
    height: 24px;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 24px;
}

.btn-close-modal {
  width: 35px;
    height: 35px;
    position: relative;
    border-radius: 6px;
}

.btn-close-modal:hover {
  opacity:.5;
}

.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(0, 123, 255, 0.3); /* полупрозрачная обводка */
  border-radius: 50%;
  border-top-color: #007bff; /* синяя обводка сверху */
  animation: spin 1s ease-in-out infinite;
  margin-right: 8px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.load-more-btn {
  display: flex;
    align-items: center;
    justify-content: center;
}

.add-btn:hover {
  opacity:.5;
}


.modern-table tr:hover {
    background-color: #f9fafb;
    cursor: pointer;
}

.tabs button {
     height: 35px;
    position: relative;
    border-radius: 6px;
    padding: 0px 10px;
    margin-right: 15px;
}

.tabs button.active {
  font-weight: 600;

}    

.quantity {
  background: transparent;
    border: 0px;
    font-size: 12px;
}

.qty-btn:hover {
  opacity:.5;
}

a {
    color: rgb(0 0 0);
    text-decoration: none;
    display: block;
}

.property {
    margin-top: 4px;
}

td .property span {
    background: transparent;
    padding: 0px;
    font-size: 10px;
    border: solid 0px #c7b0b0;
    margin: 0px;
}

.count {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 10px;
    color: #6c757d;
}

.quantity {
    background: transparent;
    border: 0px;
    font-size: 12px;
}

td p{
    margin-bottom: 2px;
    font-size: 12px;
    line-height: 14px;
}

</style>
